import { isValidHTTPUrl } from '@frontend/uri';
import { FormConfig } from '@frontend/design-system';
import { URL_ERROR_VALIDATION } from '../../../constants';
import { dropdownField, switchField, textareaField, textField } from '../../../utils/field-config-helpers';

export const schedulingConfig = {
  cancellationPolicy: textareaField(),
  walkInAppointments: switchField(),
  cancellationDuration: dropdownField(),
  cancelApptWithinDuration: switchField(),
  minTimeToBooking: dropdownField(),
  postBookingInstructions: textareaField(),
  newPatientFormLink: textField({
    validator: (props) => {
      const { value } = props;
      if (isValidHTTPUrl(value)) return '';
      else return URL_ERROR_VALIDATION;
    },
  }),
} satisfies FormConfig;

export type SchedulingFieldsTypes = typeof schedulingConfig;
